import Vue from 'vue'
import dayjs from 'dayjs'

dayjs.DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
dayjs.MIN_FORMAT = 'YYYY-MM-DD HH:mm'
dayjs.HOUR_FORMAT = 'YYYY-MM-DD HH'
dayjs.DATE_FORMAT = 'YYYY-MM-DD'
dayjs.MONTH_FORMAT = 'YYYY-MM'
dayjs.YEAR_FORMAT = 'YYYY'

dayjs.prototype.dateFormat = function () {
  return this.format(dayjs.DATE_FORMAT)
}
dayjs.prototype.dateTimeFormat = function () {
  return this.format(dayjs.DATE_TIME_FORMAT)
}

Vue.prototype.$day = dayjs
